import {
    FacebookCommentModerationOptions,
    FacebookContentTag,
    FacebookCrosspost,
    FacebookPrivacyOption,
    TwitchCategory,
    YouTubeChannel
} from "store/platforms/types";
import { PlatformId } from "../../types";
import { FacebookEdge } from "api/facebook/types";
import { TwitchIngestServer } from "@switcherstudio/switcher-api-client";
export interface DestinationDescriptor {
    name: string;
    id: string;
    platform: PlatformId;
    type?: string;
    logoUrl?: string;
    isTestStream?: boolean; // required to support private test stream with simulcasting
    platformSpecificSettings?: {
        // YouTube specific settings
        isForKids?: boolean;
        allowEmbedding?: boolean;
        selectedPrivacy?: YouTubePrivacyOptions;
        channel?: YouTubeChannel;
        // Facebook specific settings
        selectedVisibility?: FacebookPrivacyOption;
        brandedContentSelection?: string;
        contentTags?: Array<FacebookContentTag>;
        commentModerationOptions?: Array<FacebookCommentModerationOptions>;
        edge?: FacebookEdge;
        enableCrossposting?: boolean;
        crosspostOptions?: Array<FacebookCrosspost>;
        // Twitch specific settings
        ingestServer?: TwitchIngestServer | null; // Twitch ingest server
        category?: TwitchCategory | null; // Twitch category
        delay?: number | null; // Twitch delay in seconds
    };
}

export enum YouTubePrivacyOptions {
    Public = "Public",
    Unlisted = "Unlisted",
    Private = "Private"
}
